export default "/static/dashboard/build/app/img/v2/f8cb038443879d60fcd64c36a914fa21.png";